const copyButton = document.getElementById("copy-button");
const bookmarkCard = document.getElementById("bookmark-card");
const bookmarkHint = document.getElementById("bookmark-hint");
const wechatId = document.getElementById("wechat-id");
const switchPills = Array.from(document.querySelectorAll(".switch-pill"));
const planLabel = document.getElementById("plan-label");
const planPrice = document.getElementById("plan-price");
const planBadge = document.getElementById("plan-badge");
const planSubtitle = document.getElementById("plan-subtitle");
const planCta = document.getElementById("plan-cta");
const planFeatures = document.getElementById("plan-features");
const purchaseUrl = "https://fe.dtyuedan.cn/shop/ddm";

const planData = {
  basic: {
    label: "月付",
    price: "¥180",
    badge: "月付",
    subtitle: "直冲自己的账号，无需提供账号密码",
    cta: "立即购买月付",
    features: [
      {
        icon: "↗",
        title: "价格更省，效率更高",
        text: "全程使用正规开通方式处理订单。"
      },
      {
        icon: "✦",
        title: "省去支付烦恼，适合国内用户",
        text: "不用担心绑卡失败、付款不过等问题。"
      },{
        icon: "✧",
        title: "无需提供账号密码",
        text: "减少信息暴露风险，流程简单，使用安心"
      },
      {
        icon: "∿",
        title: "支持支付宝 / 微信 "
      },
      
      {
        icon: "◫",
        title: "异常问题可联系人工客服"
      }
    ]
  },
  insured: {
    label: "成品号",
    price: "¥180",
    badge: "推荐",
    subtitle: "充值好会员的 SuperGrok 账户",
    cta: "立即购买成品号",
    features: [
      {
        icon: "↗",
        title: "不想折腾官方支付和注册流程的",
        text: "提供账号、密码、邮箱密码，直接登录使用。"
        
      },
      {
        icon: "✦",
        title: "直接用、图省事的用户首选",
        text: "无需自己注册、充值，直接登录使用。"
      },
      
      {
        icon: "∿",
        title: "支持补单或退款",
        text: "根据实际异常情况按页面规则执行售后。"
      },
      {
        icon: "✧",
        title: "直接用、图省事的用户首选"
      },
      {
        icon: "◫",
        title: "降低门槛，适合新手入门",
      }
    ]
  }
};

function renderFeatures(features) {
  if (!planFeatures) {
    return;
  }

  planFeatures.innerHTML = features
    .map(({ icon, title, text }) => {
      const description = text ? `<p>${text}</p>` : "";
      return `
        <li>
          <span class="feature-icon">${icon}</span>
          <div>
            <strong>${title}</strong>
            ${description}
          </div>
        </li>
      `;
    })
    .join("");
}

function setPlan(planName) {
  const plan = planData[planName];

  if (!plan || !planLabel || !planPrice || !planBadge || !planSubtitle || !planCta) {
    return;
  }

  planLabel.textContent = plan.label;
  planPrice.textContent = plan.price;
  planBadge.textContent = plan.badge;
  planSubtitle.textContent = plan.subtitle;
  planCta.textContent = plan.cta;
  planCta.href = purchaseUrl;
  planCta.target = "_blank";
  planCta.rel = "noopener noreferrer";
  renderFeatures(plan.features);

  switchPills.forEach((pill) => {
    const isActive = pill.dataset.plan === planName;
    pill.classList.toggle("is-active", isActive);
    pill.setAttribute("aria-selected", String(isActive));
  });
}

if (switchPills.length > 0) {
  switchPills.forEach((pill) => {
    pill.addEventListener("click", () => {
      setPlan(pill.dataset.plan);
    });
  });

  setPlan("basic");
}

if (copyButton && wechatId) {
  copyButton.addEventListener("click", async () => {
    const value = wechatId.textContent.trim();

    try {
      await navigator.clipboard.writeText(value);
      copyButton.textContent = "已复制";
      window.setTimeout(() => {
        copyButton.textContent = "复制微信号";
      }, 1600);
    } catch {
      copyButton.textContent = "复制失败";
      window.setTimeout(() => {
        copyButton.textContent = "复制微信号";
      }, 1600);
    }
  });
}

function getBookmarkShortcut() {
  const platform = navigator.platform.toLowerCase();

  if (platform.includes("mac")) {
    return "Cmd + D";
  }

  return "Ctrl + D";
}

function setBookmarkHint(message) {
  if (!bookmarkHint) {
    return;
  }

  bookmarkHint.textContent = message;
}

async function handleBookmarkAction() {
  const currentUrl = window.location.href;
  const shortcut = getBookmarkShortcut();

  try {
    if (window.external && typeof window.external.AddFavorite === "function") {
      window.external.AddFavorite(currentUrl, document.title);
      setBookmarkHint("已调用浏览器收藏接口，可在书签栏里查看。");
      bookmarkCard?.classList.add("is-saved");
      return;
    }

    if (window.sidebar && typeof window.sidebar.addPanel === "function") {
      window.sidebar.addPanel(document.title, currentUrl, "");
      setBookmarkHint("已调用浏览器收藏接口，可在书签栏里查看。");
      bookmarkCard?.classList.add("is-saved");
      return;
    }

    await navigator.clipboard.writeText(currentUrl);
    setBookmarkHint(`浏览器限制无法直接收藏，链接已复制，请按 ${shortcut} 完成收藏。`);
    bookmarkCard?.classList.add("is-saved");
  } catch {
    setBookmarkHint(`请按 ${shortcut} 收藏当前页。`);
  }
}

if (bookmarkCard) {
  bookmarkCard.addEventListener("click", () => {
    handleBookmarkAction();
  });

  bookmarkCard.addEventListener("keydown", (event) => {
    if (event.key !== "Enter" && event.key !== " ") {
      return;
    }

    event.preventDefault();
    handleBookmarkAction();
  });
}
